import axios from 'axios';
export function acAxiosWidgetPromotie(val) {
    return function (dispatch) {
        axios({
            method: 'GET',
            // url: 'https://www.cnbfbtlotto.com/netbetro/Lottery/leaderboard_info?&nbroltprod=6abmcrkeoic2nujerqs2es8fe6'
            url: val[0] + 'leaderboard_info?&' + val[1],

        }).then(function (response) {
            // console.log('acWigetPromotie', response.data);
            var newUser = {
                username: response.data.username,
                position: response.data.position,
                points: response.data.points,
            }
            if (val && val.length > 2) {
                var prevLeaderboard = val[2];
                var prevUser = val[3]
            }
            // dispatch({ type: 'WIDGET_PROMOTIE', payload: { 'newLeaderboard': response.data.results, prevLeaderboard: prevLeaderboard, newUser: newUser, prevUser: prevUser } })

            dispatch({ type: 'WIDGET_PROMOTIE', 
                payload: { 
                    newLeaderboard: response.data.results, 
                    prevLeaderboard: prevLeaderboard, 
                    prevUser: prevUser,
                    newUser: newUser,
                    lastResults: response.data.last_results,
                    prize_value: response.data.prize_value,
                    promotion_name: response.data.promotion_name,
                    promotion_start: response.data.promotion_start,
                    promotion_end: response.data.promotion_end,
                    start: response.data.start,
                    end: response.data.end,
                    total_prize_value: response.data.total_prize_value
                }
            })
        }).catch(function (error) {
            console.log(error);
        });
    }

}
